import { render, staticRenderFns } from "./ClinicalData.vue?vue&type=template&id=0249a4ef&"
import script from "./ClinicalData.vue?vue&type=script&lang=js&"
export * from "./ClinicalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports